import { useTranslation } from "react-i18next";
import { z } from "zod";

export const useAuthenticationDataFormSchema = (rules?: {
  personalCodeRequired?: boolean;
  phoneNumberRequired?: boolean;
}) => {
  const { t } = useTranslation();

  return z.object({
    personalCode: rules?.personalCodeRequired
      ? z
          .string()
          .min(
            1,
            t(
              "KYC.modal.authentication.data.form.fields.personalCode.errors.required",
            ),
          )
      : z.string(),
    phoneNumber: rules?.phoneNumberRequired
      ? z
          .string()
          .min(
            1,
            t(
              "KYC.modal.authentication.data.form.fields.phoneNumber.errors.required",
            ),
          )
      : z.string(),
  });
};
